
<div class="multi-ladder-group">
  <div>
    <h3 class="title-header">Multiple Ladder<sup><i *ngIf="!isNewWindow" class="fa fa-window-restore open-window" (click)="openWindow()"></i></sup></h3>
  </div>
  <app-single-ladder *ngFor="let ladder of allLadder"
    [stopData]="ladder"
  ></app-single-ladder>
</div>